import {BrowserRouter, Route, Routes} from "react-router";
import Layout from "@/Layout.tsx";
import TableTopView from "@/tabletop/TableTopView.tsx";
import SpellWorkspace from "@/spells/SpellWorkspace.tsx";
import SpellEmpty from "@/spells/SpellEmpty.tsx";
import SpellDetailRoute from "@/spells/SpellDetailRoute.tsx";
import SpellEditor from "@/spells/SpellEditor.tsx";
import CharacterEditView from "@/characters/admin/CharacterEditView.tsx";
import CharacterCreateView from "@/characters/admin/CharacterCreateView.tsx";
import CharacterWorkspace from "@/characters/CharacterWorkspace.tsx";
import CharacterEmpty from "@/characters/CharacterEmpty.tsx";
import CharacterDetailRoute from "@/characters/CharacterDetailRoute.tsx";
import DungeonWorkspace from "@/dungeons/DungeonWorkspace.tsx";
import DungeonEmpty from "@/dungeons/DungeonEmpty.tsx";
import DungeonDetailRoute from "@/dungeons/DungeonDetailRoute.tsx";
import DungeonEditor from "@/dungeons/DungeonEditor.tsx";
import EncounterWorkspace from "@/encounter/EncounterWorkspace.tsx";
import EncounterEmpty from "@/encounter/EncounterEmpty.tsx";
import EncounterDetailRoute from "@/encounter/EncounterDetailRoute.tsx";
import EncounterEditor from "@/encounter/EncounterEditor.tsx";
import SceneWorkspace from "@/scenes/SceneWorkspace.tsx";
import SceneEmpty from "@/scenes/SceneEmpty.tsx";
import SceneDetailRoute from "@/scenes/SceneDetailRoute.tsx";
import SceneEditor from "@/scenes/SceneEditor.tsx";
import Error404 from "@/Error404.tsx";
import PlayerView from "@/player/view/PlayerView.tsx";
import BackupView from "@/backup/BackupView.tsx";
import {AuthProvider} from "./auth/AuthProvider";
import CampaignCreateView from "@/admin/campaigns/CampaignCreateView.tsx";
import CampaignEditView from "@/admin/campaigns/CampaignEditView.tsx";
import CampaignSelectionView from "@/campaigns/CampaignSelectionView.tsx";
import CampaignOverviewView from "@/campaigns/CampaignOverviewView.tsx";
import {CampaignBoundary} from "@/campaigns/CampaignContext.tsx";
import LoginErrorView from "@/auth/LoginErrorView.tsx";
import LoginView from "@/auth/LoginView.tsx";
import AdminGuard from "@/admin/AdminGuard.tsx";
import AdminLayout from "@/admin/AdminLayout.tsx";
import AdminOverviewView from "@/admin/AdminOverviewView.tsx";
import CampaignManagementView from "@/admin/campaigns/CampaignManagementView.tsx";
import GameMasterGuard from "@/campaigns/GameMasterGuard.tsx";
import AdminUsersView from "@/admin/users/AdminUsersView.tsx";
import {RealtimeProvider} from "@/api/realtime/RealtimeProvider.tsx";

function Router() {
    return <BrowserRouter>
        <Routes>
            <Route path="/login" element={<LoginView/>}/>
            <Route path="/login-error" element={<LoginErrorView/>}/>
            <Route path="*" element={<AuthenticatedApplication/>}/>
        </Routes>
    </BrowserRouter>;
}

function AuthenticatedApplication() {
    return <AuthProvider>
        <RealtimeProvider>
            <Routes>
                <Route index element={<CampaignSelectionView/>}/>
                <Route path="admin" element={<AdminGuard/>}>
                    <Route element={<AdminLayout/>}>
                        <Route index element={<AdminOverviewView/>}/>
                        <Route path="campaigns" element={<CampaignManagementView/>}/>
                        <Route path="campaigns/new" element={<CampaignCreateView/>}/>
                        <Route path="campaigns/:campaignSlug" element={<CampaignManagementView/>}/>
                        <Route path="campaigns/:campaignSlug/edit" element={<CampaignEditView/>}/>
                        <Route path="users" element={<AdminUsersView/>}/>
                        <Route path="users/:userId" element={<AdminUsersView/>}/>
                        <Route path="backups" element={<BackupView/>}/>
                        <Route path="backups/:id" element={<BackupView/>}/>
                        <Route path="*" element={<Error404/>}/>
                    </Route>
                </Route>
                <Route path="campaigns/:campaignSlug" element={<CampaignBoundary/>}>
                    <Route path="player" element={<PlayerView/>}/>
                    <Route element={<GameMasterGuard/>}>
                        <Route element={<Layout/>}>
                            <Route index element={<CampaignOverviewView/>}/>
                            <Route path="spells" element={<SpellWorkspace/>}>
                                <Route index element={<SpellEmpty/>}/>
                                <Route path="new" element={<SpellEditor mode="create"/>}/>
                                <Route path=":id" element={<SpellDetailRoute/>}/>
                                <Route path=":id/edit" element={<SpellEditor mode="edit"/>}/>
                            </Route>
                            <Route path="characters" element={<CharacterWorkspace/>}>
                                <Route index element={<CharacterEmpty/>}/>
                                <Route path="new" element={<CharacterCreateView/>}/>
                                <Route path=":id" element={<CharacterDetailRoute/>}/>
                                <Route path=":id/edit" element={<CharacterEditView/>}/>
                            </Route>
                            <Route path="dungeons" element={<DungeonWorkspace/>}>
                                <Route index element={<DungeonEmpty/>}/>
                                <Route path="new" element={<DungeonEditor mode="create"/>}/>
                                <Route path=":id" element={<DungeonDetailRoute/>}/>
                                <Route path=":id/edit" element={<DungeonEditor mode="edit"/>}/>
                                <Route path=":id/editor" element={<DungeonEditor mode="geometry"/>}/>
                            </Route>
                            <Route path="encounters" element={<EncounterWorkspace/>}>
                                <Route index element={<EncounterEmpty/>}/>
                                <Route path="new" element={<EncounterEditor mode="create"/>}/>
                                <Route path=":id" element={<EncounterDetailRoute/>}/>
                                <Route path=":id/edit" element={<EncounterEditor mode="edit"/>}/>
                                <Route path=":id/map" element={<TableTopView/>}/>
                            </Route>
                            <Route path="scenes" element={<SceneWorkspace/>}>
                                <Route index element={<SceneEmpty/>}/>
                                <Route path="new" element={<SceneEditor mode="create"/>}/>
                                <Route path=":id" element={<SceneDetailRoute/>}/>
                                <Route path=":id/edit" element={<SceneEditor mode="edit"/>}/>
                            </Route>
                            <Route path="*" element={<Error404/>}/>
                        </Route>
                    </Route>
                </Route>
                <Route path="*" element={<Error404/>}/>
            </Routes>
        </RealtimeProvider>
    </AuthProvider>;
}

export default Router;
